export const WALMART_URLS = {
  PLUS_PLANS: 'https://www.walmart.com/plus/plans',
  PLUS_ASSIST_SIGNUP: 'https://www.walmart.com/plus/assist/signup',
  WALMART_HOME: 'https://www.walmart.com',
  PLUS_STUDENT_SIGNUP: 'https://www.walmart.com/plus/student/verify',
} as const;

export type WalmartUrl = (typeof WALMART_URLS)[keyof typeof WALMART_URLS];
